import _ from "lodash";
import React, { useState } from "react";

/** Components */
import { Modal, Button, TextInput } from "@toddle-edu/ds-web";

/** Styles */
import classes from "./ToddleDocNameModal.scss";
import { useI18n } from "Hooks";
const customModalStyles = {
  body: { paddingBottom: "48px" },
};

const ToddleDocNameModal = ({
  title,
  showSaveButton,
  closeModal,
  onDocumentNameSubmit,
  attachmentName,
}) => {
  const { t } = useI18n();
  const [templateName, setTemplateName] = useState(attachmentName || "");

  const handleNameInput = e => {
    setTemplateName(e?.target?.value);
  };

  const handleCreateDocument = () => {
    onDocumentNameSubmit({
      name: templateName.trim(),
      isRenameClicked: showSaveButton,
    });
  };

  return (
    <Modal
      dsVersion={"2.0"}
      hasOverlay
      onClose={closeModal}
      width={"480px"}
      height="fit-content"
    >
      <Modal.Header>
        <h5>{title}</h5>
      </Modal.Header>
      <Modal.Body style={customModalStyles.body}>
        <div>
          <TextInput
            dsVersion={"2.0"}
            size="large"
            label={t("common:document_name")}
            value={templateName}
            placeholder={t("common:name_your_document")}
            onChange={handleNameInput}
            autoFocus={true}
          />
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.buttonContainer}>
          <Button
            dsVersion={"2.0"}
            size="medium"
            variant={"neutral"}
            type={"outlined"}
            onClick={closeModal}
          >
            {t("common:cancel")}
          </Button>
          <Button
            dsVersion={"2.0"}
            size="medium"
            variant={"primary"}
            type={"fill"}
            onClick={handleCreateDocument}
            shortcut={{ code: "Enter" }}
            disabled={_.isEmpty(_.trim(templateName))}
          >
            {showSaveButton ? t("common:save") : t("common:done")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ToddleDocNameModal;
